// extracted by mini-css-extract-plugin
export default {"container":"Oa","header":"Pa","logodesktop":"Qa","logomobile":"Ra","imgcontainer":"Sa","slidercontainer":"Ta","slick-slider":"Ua","slick-initialized":"Va","sliderbox":"Wa","headline":"Xa","mainheadline":"Ya","capitalize":"Za","desc":"ab","descitalic":"bb","desccenter":"cb","descborder":"eb","subdesc":"fb","welcomeslide":"gb","desccard":"hb","img":"ib","button":"jb","buttonskip":"kb","customPosition":"lb"};
    if(module.hot) {
      // 1737143659353
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  